<template>
<div class="form">

 <h1 align="center" style="text-decoration: underline overline;">WAJARAN</h1>


<!-- DATATABLE  -->
<v-card  color="rgba(217, 217, 217, 0.5)" class="mb-4">
      <v-card-title>
          Senarai
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>

        <v-spacer></v-spacer>
          <v-btn
          color="error"
          small
          @click="dialogPengesahan=true;"
          >
            Padam
          </v-btn>

      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dataWajaran"
        :search="search"
        class="ml-3 mr-3"
        @click:row="handleClick"
        :footer-props="{'items-per-page-options':[3,15, 30, 50, 100, -1]}"
      >
        <!-- <template v-slot:top>
        <v-btn
          class="mx-2"
          dark
          color="primary"
          @click="dialog=true;"
        >
          <v-icon dark>
            mdi-plus
          </v-icon>
          Tambah Wajaran
        </v-btn>
          <v-btn
            class="ma-2"
            color="primary"
            text-color="white"
            rounded
            @click="dialog=true;"
          >
            Tambah Strata
          </v-btn>
        </template> -->

      </v-data-table>


</v-card>

<v-card>

  <v-card-title>
    Tambah Wajaran
  </v-card-title>

  <v-card-text>
    <v-form 
      ref="form"
      v-model="valid"
      lazy-validation
    >
     <v-row>      
      <v-col
        md="12"
        cols="12"
      >
        <v-radio-group v-model='selectedSample'>
          <template v-slot:label>
            <div>Sila Pilih <strong>Pendapatan atau Perbelanjaan</strong></div>
          </template>
          <v-radio value="1">
            <template v-slot:label>
              <div><strong style="color:#F68F39">Pendapatan</strong></div>
            </template>
          </v-radio>
          <v-radio value="2">
            <template v-slot:label>
              <div><strong style="color:#00B2FF">Perbelanjaan</strong></div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row v-show="selectedSample == 1">
      <v-row>
        <v-card-title> Pendapatan </v-card-title>
      </v-row>

      <v-row>
        <v-col cols="3" md="3">
          <v-text-field v-model="selectedTahun" placeholder="Tahun" hint="cth: 2022" label="Tahun" outlined dense>
          </v-text-field>
        </v-col>

        <v-col cols="3" md="3">
          <v-text-field v-model="selectedPusingan" placeholder="Pusingan" hint="cth: 01" label="Pusingan" outlined dense>
          </v-text-field>
        </v-col>

        <v-col cols="3" md="3">
          <v-autocomplete
            outlined
            dense
            v-bind:label="$t('negeri')"
            :items="listNegeri"
            :item-text="item => item.negeriID +' - '+ item.negeri"
            return-object
            v-model="selectedNegeri"
          ></v-autocomplete>
        </v-col>

        <v-col cols="3" md="3">
          <v-text-field v-model="selectedDP" placeholder="DP" hint="cth: 01" label="DP" outlined dense>
          </v-text-field>
        </v-col>

        <v-col cols="3" md="3">
          <v-text-field v-model="selectedStrata" placeholder="Strata" hint="cth: 1" label="Strata" outlined dense>
          </v-text-field>
        </v-col>

        <v-col cols="3" md="3">
          <v-text-field v-model="selectedKW" placeholder="KW" hint="cth: 1" label="KWKIRB" outlined dense>
          </v-text-field>
        </v-col>

        <v-col cols="3" md="3">
          <v-text-field v-model="wajaranValue" placeholder="Wajaran" hint="cth: 1.12" label="Wajaran" outlined dense>
          </v-text-field>
        </v-col>

      

        <v-col cols="3" md="3">
          <v-btn
             color="#F68F39"
            @click='simpanWajaranPendapatan()'
          >
           Simpan
          </v-btn>
        </v-col>
      </v-row>
    </v-row>
  </v-form>

    <v-row v-show="selectedSample == 2">
      <v-row>
        <v-card-title> Perbelanjaan </v-card-title>
      </v-row>

      <v-row>
        <v-col cols="3" md="3">
          <v-text-field v-model="selectedTahun" placeholder="Tahun" hint="cth: 2022" label="Tahun" outlined dense>
          </v-text-field>
        </v-col>

        <v-col cols="3" md="3">
          <v-text-field v-model="selectedPusingan" placeholder="Pusingan" hint="cth: 01" label="Pusingan" outlined dense>
          </v-text-field>
        </v-col>

        <v-col cols="3" md="3">
          <v-autocomplete
            outlined
            dense
            v-bind:label="$t('negeri')"
            :items="listNegeri"
            :item-text="item => item.negeriID +' - '+ item.negeri"
            return-object
            v-model="selectedNegeri"
          ></v-autocomplete>
        </v-col>

        <v-col cols="3" md="3">
          <v-text-field v-model="selectedDP" placeholder="DP" hint="cth: 01" label="DP" outlined dense>
          </v-text-field>
        </v-col>

        <v-col cols="3" md="3">
          <v-text-field v-model="selectedStrata" placeholder="Strata" hint="cth: 1" label="Strata" outlined dense>
          </v-text-field>
        </v-col>

        <v-col cols="3" md="3">
          <v-text-field v-model="selectedKW" placeholder="KW" hint="cth: 01" label="KWKIRB" outlined dense>
          </v-text-field>
        </v-col>

        <v-col cols="3" md="3">
          <v-text-field v-model="wajaranValue" placeholder="Wajaran" hint="cth: 1.12" label="Wajaran" outlined dense>
          </v-text-field>
        </v-col>

        <v-col cols="3" md="3">
          <!-- <v-btn
             color="primary"
            @click='simpanWajaranPendapatan()'
          >
           Simpan
          </v-btn> -->
          <v-btn color="success">Simpan</v-btn>
        </v-col>
      </v-row>
    </v-row>



  </v-card-text>

</v-card>




<v-dialog
      v-model="successDialog"
      max-width="800"
      height="200"
    >
    <v-card
      color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>

      <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              OK
            </v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>

 

</div>
</template>
<script>
import axios from '../../plugins/axios'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    
    async beforeMount(){
        
      var listNegeri = await lookupFieldServices.getNegeri();
      this.listNegeri = listNegeri.data.data;

      this.getData();
    },
    data: () => ({
        successDialog: false,

        search:'',

        selectedSample: '',
        selectedNegeri:'',
        selectedTahun: '',
        selectedPusingan: '',
        selectedDP: '',
        selectedStrata: '',
        wajaranValue: '',
        selectedKW: '',
        listNegeri:'',
        dataWajaran:[],

        headers: [
          //{ text: "No", value: "no" },
          {text: 'Tahun', value: 'tahun'},
          {text: 'Pusingan', value: 'P'},
          {text: 'Negeri', value: 'NG'},
          {text: 'DP', value: 'DP'},
          {text: 'Strata', value: 'ST'},
          {text: 'Warganegara', value: 'KWKIRB'},
          {text: 'Wajaran', value: 'wajaran'},
        ],
        valid: true,
      
    }),

    methods: {

      reset() {
        this.$refs.form.reset();
       
      },

      async getData(){
        
      //  console.log("masuk wajaran")
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getWajaran`, {
            })
            var dataz = res.data.data
            this.dataWajaran = dataz;
           // console.log(this.dataWajaran)
          } catch (error) {
            
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },

     async simpanWajaranPendapatan(){
    //  console.log("masuk simpan")
         try {
          //console.log("masuk simpan2")

              //const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/HK1`, {
              const res = await axios.post(`${process.env.VUE_APP_API_URL}/JadualAwalan/simpanWajaranPendapatan`, {
                S: this.selectedSample,
                tahun: this.selectedTahun,
                P: this.selectedPusingan,
                NG: this.selectedNegeri.negeriID,
                DP: this.selectedDP,
                ST: this.selectedStrata,
                wajaran: this.wajaranValue,
                KWKIRB:this.selectedKW

               
              })
                this.res = res.data;
                this.successMessage = 'Data Disimpan!';
                this.successDialog = true;
                this.getData();
                this.reset();
                window.scrollTo(0, 0);

                
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
       
           

      },

      simpanPerbelanjaan(){

      },

      handleClick(row) {
// console.log(row)
// console.log(this.listNegeri)
          this.successDialog = true;
          this.kemaskiniDialog = true;
          this.successMessage = "Sila mulakan pengemaskinian!";
          // setTimeout(() => (this.kemaskiniDialog = false), 1000);
          this.butangSimpan = false;
          this.butangKemaskini = true;
          this.selectedSample = row.S;
          this.selectedTahun = row.tahun;
          this.selectedPusingan = row.P;
          this.selectedDP = row.DP;
          this.selectedStrata = row.ST;
          this.wajaranValue = row.wajaran;
          this.selectedKW = row.KWKIRB;

          for(var i = 0; i<this.listNegeri.length;i++){
              if(row.NG == this.listNegeri[i].negeriID){
                this.selectedNegeri = this.listNegeri[i];
              }
            }
          
      },
    
    }
}
</script>

